import React, { RefObject } from "react"
import { TourStep } from "../TourDocument"
import * as FFIcons from "../../../../libs/corporate/icons/outlined/other/FileAndFolderCollection"
import * as ActionIcons from "../../../../libs/corporate/icons/outlined/editor/ActionCollection"
import * as MainIcons from "../../../../libs/corporate/icons/outlined/action/MainCollection"
import * as RotationIcons from "../../../../libs/corporate/icons/outlined/directions/RotationCollection"
import { EmptySquareIcon } from "../../../../libs/corporate/icons/outlined/suggested/SquareCollection"

export interface DisposalRegistrarGridTourRefs {
    commandsPanel: RefObject<HTMLDivElement>
    totalCount: RefObject<HTMLDivElement>
    grid: RefObject<HTMLDivElement>
}

const iconRowStyle = { display: "flex", alignItems: "center", margin: "5px", gap: "10px" }

export const getDisposalRegistrarGridTourSteps = (refs: DisposalRegistrarGridTourRefs): TourStep[] => [
    {
        target: () => refs.commandsPanel.current,
        description: (
            <div>
                Панель содержит стандартные команды управления:
                <div style={iconRowStyle}>
                    <FFIcons.FilePlusIcon /> Добавить запись
                </div>
                <div style={iconRowStyle}>
                    <ActionIcons.HighlightIcon /> Редактировать запись
                </div>
                <div style={iconRowStyle}>
                    <MainIcons.Delete2Icon /> Удалить запись
                </div>
                <div style={iconRowStyle}>
                    <MainIcons.DeleteIcon /> Восстановить запись
                </div>
                <div style={iconRowStyle}>
                    <RotationIcons.RotationRightIcon /> Обновить
                </div>
                <div style={iconRowStyle}>
                    <EmptySquareIcon /> Отображать удалённые записи
                </div>
            </div>
        ),
        placement: "bottom",
    },
    {
        target: () => refs.totalCount.current,
        description: "Здесь отображается количество отображаемых записей.",
        placement: "bottom",
    },
    {
        target: () => refs.grid.current,
        description: "Это таблица со списком регистраторов выбытия.",
        placement: "top",
    },
]
